import { render } from "./UseInventoryCase.vue?vue&type=template&id=785677db&scoped=true"
import script from "./UseInventoryCase.vue?vue&type=script&lang=js"
export * from "./UseInventoryCase.vue?vue&type=script&lang=js"

import "./UseInventoryCase.vue?vue&type=style&index=0&id=785677db&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785677db"]])

export default __exports__